import { Component, OnDestroy } from '@angular/core';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { SettingValueModel } from 'src/app/models/api/setting-value.model';
import { CachedSettingsApiClient } from 'src/app/services/api-clients/cached-settings.apiclient';
import { PermissionsEnum, PlatformSettings } from 'src/app/constants/settings.enum';
import { SettingsService } from '../../settings.service';
import { SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';

class WorkflowSettingPageModel {
  settingName!: string;
  permissionName!: PermissionsEnum;
  constructor(settingName: string, permissionName: PermissionsEnum) {
    this.settingName = settingName;
    this.permissionName = permissionName;
  }
}

@Component({
  templateUrl: './settings-application-requests.page.html'
})
export class SettingsApplicationRequestsPage implements OnDestroy {
  organisationIdSubscription: Subscription;
  selectedOrganisationGuid: string = "";
  allowedWorkflowSettings: SettingValueModel[] = [];

  settingsAndPermissionCombo: WorkflowSettingPageModel[] = [
    // Generic
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_SignYourself, PermissionsEnum.Perm_WF_SignYourself),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_SignatureRequest, PermissionsEnum.Perm_WF_SignatureRequest),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_SecureFileSharing, PermissionsEnum.Perm_WF_SecureFileSharing),
    // Belasting
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_IncomeTax, PermissionsEnum.Perm_WF_IncomeTax),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_CorporateTax, PermissionsEnum.Perm_WF_CorporateTax),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_VAT, PermissionsEnum.Perm_WF_VAT),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_EUVAT, PermissionsEnum.Perm_WF_EUVAT),
    // Deponeren
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_Filing, PermissionsEnum.Perm_WF_Filing),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_FilingWithReport, PermissionsEnum.Perm_WF_FilingWithReport),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_LinkingAndSigning, PermissionsEnum.Perm_WF_LinkingAndSigning),
    // SBR + Noab
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_SbrBank, PermissionsEnum.Perm_WF_SbrBank),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_SbrBankWithReport, PermissionsEnum.Perm_WF_SbrBankWithReport),
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_NoabBankAudit, PermissionsEnum.Perm_WF_NoabBankAudit),
    // Wwft
    new WorkflowSettingPageModel(PlatformSettings.Allow_WF_Wwft, PermissionsEnum.Perm_WF_Wwft),
  ];

  getSetting(settingName: string) {
    return SingleOrDefault(this.allowedWorkflowSettings, "name", settingName)?.isEnabled ?? false;
    // return this.allowedWorkflowSettings.filter(x => x.name == settingName)[0].isEnabled;
  }

  constructor(private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private cachedSettingsApiClient: CachedSettingsApiClient, private settingsService: SettingsService) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationGuid) return;
      this.selectedOrganisationGuid = organisationId;
      this.cachedSettingsApiClient.getWorkflowSettings(this.selectedOrganisationGuid).subscribe(settings =>
        this.allowedWorkflowSettings = settings
      );
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Application(this.selectedOrganisationGuid), BreadCrumbOptions.Application_Request(this.selectedOrganisationGuid));

    });
  }

  update(settingName: any, value: any) {
    this.settingsService.updateSettings([{ key: settingName, value: value }], this.selectedOrganisationGuid);
    this.cachedSettingsApiClient.refreshCache();
  }
  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }
}